module.exports = __webpack_public_path__ + "static/media/logo-liberté.eb194437.png";